/**
 * GUID/UUID validation helpers.
 *
 * The frontend had no GUID validator; this is the shared one. Reusable for any
 * GUID-format field (e.g. EZCM Domain ID, OAuth client IDs).
 */

/** Canonical hyphenated GUID: 8-4-4-4-12 hex (the .NET `Guid` "D" format), case-insensitive. */
const GUID_RE = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

/** True if `value` (trimmed) is a canonical hyphenated GUID. Empty/non-GUID values return false. */
export function isValidGuid(value: string): boolean {
    return GUID_RE.test(value.trim());
}
